import {Action} from 'redux'
import {ProgramCategoryModel} from '../Model/ProgramCategoryModel'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

const initialProgramCategoryState: IProgramCategoryState = {
  data: {
    programCategory: [],
    meta: [],
  },
  sortProgramCategoryData: [],
  programCategoryList: {programCategory: []},
  deleteSuccess: false,
  enableSuccess: false,
  disableSuccess: false,
  singleEnableSuccess: false,
  singleDisableSuccess: false,
  loading: false,
  success: false,
}

export interface IProgramCategoryState {
  data?: {
    programCategory?: ProgramCategoryModel[]
    meta?: {[key: string]: string | number}[]
  }
  sortProgramCategoryData?: IProgramCategoryState[]
  programCategoryList?: {programCategory: ProgramCategoryModel[]}
  deleteSuccess?: boolean
  enableSuccess?: boolean
  disableSuccess?: boolean
  singleEnableSuccess?: boolean
  singleDisableSuccess?: boolean
  loading?: boolean
  success?: boolean
}

export const reducer = (
  state: IProgramCategoryState = initialProgramCategoryState,
  action: ActionWithPayload<IProgramCategoryState>
) => {
  switch (action.type) {
    case actionTypes.GET_ALL_PROGRAM_CATEGORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_ALL_PROGRAM_CATEGORY_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        programCategoryList: action.payload,
        loading: false,
      }
    }

    case actionTypes.GET_ALL_PROGRAM_CATEGORY_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //GET ProgramCategory DATA
    case actionTypes.GET_PROGRAM_CATEGORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_PROGRAM_CATEGORY_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_PROGRAM_CATEGORY_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Add ProgramCategory
    case actionTypes.ADD_PROGRAM_CATEGORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.ADD_PROGRAM_CATEGORY_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.ADD_PROGRAM_CATEGORY_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.RESET_PROGRAM_TAG: {
      return {
        ...state,
        data: [],
        success: false,
      }
    }

    //Update ProgramCategory
    case actionTypes.UPDATE_PROGRAM_CATEGORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.UPDATE_PROGRAM_CATEGORY_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.UPDATE_PROGRAM_CATEGORY_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Delete
    case actionTypes.DELETE_PROGRAM_CATEGORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.DELETE_PROGRAM_CATEGORY_SUCCESS: {
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DELETE_PROGRAM_CATEGORY_FINISH: {
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
      }
    }

    //Enable
    case actionTypes.ENABLE_PROGRAM_CATEGORY_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.ENABLE_PROGRAM_CATEGORY_SUCCESS: {
      return {
        ...state,
        enableSuccess: true,
        loading: false,
      }
    }

    case actionTypes.ENABLE_PROGRAM_CATEGORY_FINISH: {
      return {
        ...state,
        loading: false,
        enableSuccess: false,
      }
    }

    //disable
    case actionTypes.DISABLE_PROGRAM_CATEGORY_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.DISABLE_PROGRAM_CATEGORY_SUCCESS: {
      return {
        ...state,
        disableSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DISABLE_PROGRAM_CATEGORY_FINISH: {
      return {
        ...state,
        loading: false,
        disableSuccess: false,
      }
    }
    //Enable
    case actionTypes.SINGLE_ENABLE_PROGRAM_CATEGORY_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_ENABLE_PROGRAM_CATEGORY_SUCCESS: {
      const changedData: any = action.payload?.data?.programCategory
      let newData = state?.data?.programCategory?.map((data) => {
        if (data?.id === changedData[0]?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })
      return {
        ...state,
        data: {...state, meta: state?.data?.meta, programCategory: newData},
        singleEnableSuccess: true,
        toggleLoading: false,
      }
    }

    case actionTypes.SINGLE_ENABLE_PROGRAM_CATEGORY_FINISH: {
      return {
        ...state,
        singleEnableSuccess: false,
        toggleLoading: false,
      }
    }

    //Disable
    case actionTypes.SINGLE_DISABLE_PROGRAM_CATEGORY_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_DISABLE_PROGRAM_CATEGORY_SUCCESS: {
      const changedData: any = action.payload?.data?.programCategory
      let newData = state?.data?.programCategory?.map((data) => {
        if (data?.id === changedData[0]?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })

      return {
        ...state,
        data: {...state, meta: state?.data?.meta, programCategory: newData},
        singleDisableSuccess: true,
        toggleLoading: false,
      }
    }

    case actionTypes.SINGLE_DISABLE_PROGRAM_CATEGORY_FINISH: {
      return {
        ...state,
        singleDisableSuccess: false,
        toggleLoading: false,
      }
    }

    // sort
    case actionTypes.SORT_PROGRAM_CATEGORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.SORT_PROGRAM_CATEGORY_SUCCESS: {
      return {
        ...state,
        sortProgramCategoryData: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.SORT_PROGRAM_CATEGORY_FINISH: {
      return {
        ...state,
        loading: false,
        success: false,
      }
    }

    case actionTypes.SORT_PROGRAM_CATEGORY_RESET: {
      return {
        ...state,
        loading: false,
        success: false,
        sortProgramCategoryData: [],
      }
    }

    default:
      return state
  }
}
